import { PickupTableState } from './pickup-table.state';
import { Action, createReducer, on } from '@ngrx/store';
import {
    pickupTableChangePage, pickupTableChangeQuery,
    pickupTableFailure, pickupTableMasterToggle,
    pickupTableRequest, pickupTableSetSelection, pickupTableSort,
    pickupTableSuccess, pickupTableToggle
} from './pickup-table.actions';

const initialState: PickupTableState = {
    query: {
        sortColumn: 'date',
        sortDescending: true,
        reference: null,
        dateAfter: null,
        dateBefore: null,
        pageNumber: 1,
        itemsPerPage: 25
    },
    page: [],
    totalCount: null,
    filteredCount: null,
    busy: false,
    error: false,
    selection: []
};

const reducer = createReducer(
    initialState,
    on(pickupTableRequest, (state) => ({
        ...state,
        busy: true,
        error: false
    })),
    on(pickupTableSuccess, (state, { totalCount, page }) => ({
        ...state,
        busy: false,
        page,
        totalCount,
        error: false
    })),
    on(pickupTableFailure, (state) => ({
        ...state,
        busy: false,
        error: true
    })),
    on(pickupTableChangePage, (state, { pageNumber, itemsPerPage }) => ({
        ...state,
        selection: [],
        query: { ...state.query, pageNumber, itemsPerPage }
    })),
    on(pickupTableChangeQuery, (state, { query }) => ({
        ...state,
        query
    })),
    on(pickupTableSort, (state, { id, descending }) => ({
        ...state,
        query: { ...state.query, sortColumn: id, sortDescending: descending }
    })),
    on(pickupTableSetSelection, (state, { selection }) => ({
        ...state,
        selection
    })),
    on(pickupTableToggle, (state, { id }) => ({
        ...state,
        selection: state.selection.indexOf(id) === -1 ? [ ...state.selection, id ] : state.selection.filter((sid) => sid !== id)
    })),
    on(pickupTableMasterToggle, (state) => ({
        ...state,
        selection: state.selection.length === 0 ? state.page.map(h => h.id) : []
    }))
);

export function pickupTableReducer(state: PickupTableState | undefined, action: Action): any {
    return reducer(state, action);
}
